import { render, staticRenderFns } from "./FeaturedSelected.vue?vue&type=template&id=9ff042ba&"
import script from "./FeaturedSelected.vue?vue&type=script&lang=js&"
export * from "./FeaturedSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports